import React from "react";
import { Tooltip, UserIcon } from "../../../../../shared/infrastructure";

type OfferCardSalesPersonProps = {
  salesPersonName: string;
};

export const OfferCardSalesPerson = ({
  salesPersonName,
}: OfferCardSalesPersonProps): React.ReactElement => {
  return (
    <Tooltip text="Salesperson">
      <div className="relative flex items-center gap-1 text-[10px] font-[300] capitalize text-[#484848]">
        <UserIcon className="text-black" />
        <span className="ml-[2px] overflow-hidden text-ellipsis whitespace-nowrap capitalize">
          {salesPersonName}
        </span>
      </div>
    </Tooltip>
  );
};
